/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-16 18:09:56
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-05-17 14:43:28
 * @Description: 
 */

export default {
  protocol: "",
  domain: "",
  action: {
    globalUserGetUserInfo2: '/global/User/getUserInfo2'
  }
}